import { createSvgIcon } from '@mui/material/utils';

// MUI has no crown; a badge with the crown cut out, like StarsRounded and OfflineBoltRounded
const CrownIcon = createSvgIcon(
  <path fillRule="evenodd" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.1 9.5q-.1-.6.5-.4L9.3 11.7 11.6 7.4q.4-.7.8 0L14.7 11.7 17.4 9.1q.6-.2.5.4L16.6 16.2q-.1.5-.6.5H8q-.5 0-.6-.5z" />,
  'Crown'
);

export default CrownIcon;
